

import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({

    title:{
        color: 'black',
        padding: '6% 0% 4% 4%',
        fontSize: 'rem',
        fontFamily: 'sans-serif',
        fontWeight: 'bold',
    },
}))